import React, { useState } from 'react';
import moment from 'moment';

const PAGE_SIZE = 10;

function formatRelDate(dateStr) {
    if (!dateStr) return '–';
    const m = moment(dateStr);
    if (!m.isValid()) return '–';
    const days = moment().diff(m, 'days');
    if (days <= 0) return 'hoje';
    if (days === 1) return 'ontem';
    if (days < 30) return `há ${days} dias`;
    if (days < 365) { const mo = Math.floor(days / 30); return `há ${mo} ${mo === 1 ? 'mês' : 'meses'}`; }
    const y = Math.floor(days / 365);
    return `há ${y} ${y === 1 ? 'ano' : 'anos'}`;
}

function formatAbsDate(dateStr) {
    if (!dateStr) return '–';
    const m = moment(dateStr);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '–';
}

const SEV_STYLE = {
    high:   { border: '#dc2626', bg: '#fff5f5', color: '#dc2626' },
    medium: { border: '#d97706', bg: '#fffbeb', color: '#d97706' },
    low:    { border: '#2563eb', bg: '#eff6ff', color: '#2563eb' },
};

function InstalledApps({ installedApps, detectedSuspiciousApps }) {
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('recent');
    const [page, setPage] = useState(1);
    const [expanded, setExpanded] = useState(null);

    const raw = installedApps || [];
    const total = raw.length;
    const suspMap = new Map(
        (detectedSuspiciousApps || []).map(a => [a.package_name, { sev: a.risk, ruleLabel: a.name }])
    );

    let list = raw.map(app => {
        const pkg = app.package_name || '';
        const seg = pkg.split('.').pop() || '?';
        const susp = suspMap.get(pkg) || null;
        return {
            pkg,
            seg,
            initial: (seg[0] || '?').toUpperCase(),
            installedRel: formatRelDate(app.first_install_date),
            updatedRel: formatRelDate(app.last_update_date),
            installedAbs: formatAbsDate(app.first_install_date),
            updatedAbs: formatAbsDate(app.last_update_date),
            neverUpdated: app.first_install_date === app.last_update_date,
            _u: app.last_update_date || '',
            susp,
        };
    });

    const q = search.trim().toLowerCase();
    if (q) list = list.filter(a => a.pkg.toLowerCase().includes(q));
    if (sort === 'az') list.sort((a, b) => a.seg.localeCompare(b.seg));
    else list.sort((a, b) => new Date(b._u) - new Date(a._u));

    const totalFiltered = list.length;
    const totalPages = Math.max(1, Math.ceil(totalFiltered / PAGE_SIZE));
    const currentPage = Math.min(Math.max(1, page), totalPages);
    const paged = list.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);
    const rangeStart = totalFiltered === 0 ? 0 : (currentPage - 1) * PAGE_SIZE + 1;
    const rangeEnd = Math.min(currentPage * PAGE_SIZE, totalFiltered);

    const toggle = (pkg) => setExpanded(prev => prev === pkg ? null : pkg);

    const handleSearch = (e) => { setSearch(e.target.value); setPage(1); };

    return (
        <div style={{ borderTop: '1px solid #e2e8f0', marginTop: '22px', paddingTop: '18px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', marginBottom: '14px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '700', fontSize: '15px', color: '#0b1f82' }}>Aplicativos instalados</span>
                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '12px', lineHeight: '1', color: '#0b1f82', background: '#eff6ff', padding: '5px 9px', borderRadius: '999px' }}>
                        {q ? `${totalFiltered} de ${total}` : `${total} aplicativos`}
                    </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: '8px', padding: '8px 12px', width: '220px', maxWidth: '48vw' }}>
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        <input
                            value={search}
                            onChange={handleSearch}
                            placeholder="Buscar aplicativo..."
                            style={{ border: 'none', outline: 'none', background: 'transparent', fontFamily: '"Open Sans"', fontSize: '13px', color: '#1e293b', width: '100%' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', background: '#f1f5f9', borderRadius: '8px', padding: '3px' }}>
                        {[['recent', 'Recentes'], ['az', 'A–Z']].map(([key, label]) => (
                            <button
                                key={key}
                                onClick={() => { setSort(key); setPage(1); }}
                                style={{
                                    border: 'none', cursor: 'pointer', padding: '7px 12px', borderRadius: '6px',
                                    fontFamily: '"Open Sans"',
                                    fontWeight: sort === key ? '600' : '500',
                                    fontSize: '12px',
                                    background: sort === key ? '#fff' : 'transparent',
                                    color: sort === key ? '#0b1f82' : '#64748b',
                                    boxShadow: sort === key ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
                                }}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {total === 0 ? (
                <div style={{ padding: '28px', textAlign: 'center', color: '#94a3b8', fontFamily: '"Open Sans"', fontSize: '14px', lineHeight: '1.4' }}>
                    Nenhum aplicativo instalado foi encontrado.
                </div>
            ) : totalFiltered === 0 ? (
                <div style={{ padding: '28px', textAlign: 'center', color: '#94a3b8', fontFamily: '"Open Sans"', fontSize: '14px', lineHeight: '1.4' }}>
                    Nenhum aplicativo encontrado com o nome "{search}".
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {paged.map(app => {
                        const isExpanded = expanded === app.pkg;
                        const ss = app.susp ? SEV_STYLE[app.susp.sev] : null;
                        return (
                            <div
                                key={app.pkg}
                                onClick={() => toggle(app.pkg)}
                                style={{ cursor: 'pointer', padding: '12px 4px', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '10px' }}
                            >
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span style={{ width: '26px', height: '26px', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '"Open Sans"', fontWeight: '700', fontSize: '12px', color: ss ? ss.color : '#0b1f82', background: '#eff6ff', flex: 'none' }}>
                                            {app.initial}
                                        </span>
                                        <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '13px', lineHeight: '1.35', color: '#1e293b', wordBreak: 'break-all', flex: 1 }}>{app.pkg}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '10px 0 0 36px' }}>
                                        <span style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#cbd5e1', flex: 'none' }}></span>
                                        <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '12px', lineHeight: '1', color: '#64748b', whiteSpace: 'nowrap' }}>instalado {app.installedRel}</span>
                                        <span style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#cbd5e1', flex: 'none', marginLeft: '8px' }}></span>
                                        <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '12px', lineHeight: '1', color: '#64748b', whiteSpace: 'nowrap' }}>atualizado {app.updatedRel}</span>
                                    </div>
                                    {isExpanded && (
                                        <div style={{ margin: '12px 0 2px 36px', display: 'flex', gap: '40px', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '11px', letterSpacing: '.04em', textTransform: 'uppercase', color: '#94a3b8' }}>Primeira instalação</span>
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '13px', color: '#1e293b' }}>{app.installedAbs}</span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '11px', letterSpacing: '.04em', textTransform: 'uppercase', color: '#94a3b8' }}>Última atualização</span>
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '13px', color: '#1e293b' }}>{app.updatedAbs}</span>
                                        </div>
                                        {app.neverUpdated && (
                                            <span style={{ fontFamily: '"Open Sans"', fontWeight: '500', fontSize: '12px', lineHeight: '1', color: '#94a3b8', background: '#f1f5f9', padding: '5px 9px', borderRadius: '999px' }}>Nunca atualizado</span>
                                        )}
                                        </div>
                                    )}
                                </div>
                                {ss && (
                                    <span style={{ fontFamily: '"Open Sans"', fontWeight: '600', fontSize: '11px', lineHeight: '1', color: ss.color, background: 'transparent', border: `1px solid ${ss.border}`, padding: '3px 7px', borderRadius: '4px', whiteSpace: 'nowrap', flex: 'none' }}>
                                        {app.susp.sev === 'high' ? 'Alto' : app.susp.sev === 'medium' ? 'Médio' : 'Baixo'}
                                    </span>
                                )}
                                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flex: 'none' }}>
                                    <path d={isExpanded ? 'M7 15l5-5 5 5' : 'M7 9l5 5 5-5'} stroke={isExpanded ? '#0b1f82' : '#94a3b8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        );
                    })}
                </div>
            )}

            {totalPages > 1 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', paddingTop: '14px' }}>
                    <span style={{ fontFamily: '"Open Sans"', fontSize: '12px', lineHeight: '1', color: '#94a3b8' }}>
                        Mostrando {rangeStart}–{rangeEnd} de {totalFiltered}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <button
                            onClick={() => setPage(p => Math.max(1, p - 1))}
                            disabled={currentPage === 1}
                            style={{ width: '32px', height: '32px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', cursor: currentPage === 1 ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: currentPage === 1 ? 0.4 : 1 }}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#64748b" strokeWidth="2" strokeLinecap="round"/></svg>
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
                            <button
                                key={n}
                                onClick={() => setPage(n)}
                                style={{
                                    minWidth: '32px', height: '32px', padding: '0 8px', borderRadius: '6px',
                                    border: n === currentPage ? '1px solid #0b1f82' : '1px solid #e2e8f0',
                                    background: n === currentPage ? '#0b1f82' : '#fff',
                                    color: n === currentPage ? '#fff' : '#64748b',
                                    fontFamily: '"Open Sans"',
                                    fontWeight: n === currentPage ? '600' : '500',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                }}
                            >
                                {n}
                            </button>
                        ))}
                        <button
                            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                            disabled={currentPage === totalPages}
                            style={{ width: '32px', height: '32px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', cursor: currentPage === totalPages ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: currentPage === totalPages ? 0.4 : 1 }}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="#64748b" strokeWidth="2" strokeLinecap="round"/></svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default InstalledApps;
